<template>
    <div id="app">
        <router-view v-if="isRouterAlive" />
    </div>
</template>

<script type="text/javascript">
export default {
    provide() {
        return {
            reload: this.reload,
        };
    },

    data() {
        return {
            isRouterAlive: true,
        };
    },
    watch: {},
    methods: {
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            });
        },
    },
    mounted() {
        //
    },
};
</script>

<style lang="less">
@import "./assets/style/base.css";
@import "./assets/style/reset.less";

#app {
    height: 100%;
}
</style>
